import React, { useEffect, useState } from "react";
import { Button, Modal, Alert as BSAlert } from "react-bootstrap";
import Alert from "react-s-alert";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";

const SendTaskSmsModal = ({ show, tasks, onClose, onSent }) => {
  const [template, setTemplate] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(true);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    SalesPersonTasksService.getOptions()
      .then(data => {
        setTemplate(data.waitlist_template || null);
        setLoadingTemplate(false);
      })
      .catch(() => {
        setLoadingTemplate(false);
      });
  }, []);

  const sendSms = () => {
    setSending(true);
    SalesPersonTasksService.bulkSendSms(tasks.map(t => t.id))
      .then(data => {
        const skipped = data.skipped || [];
        if (data.queued > 0) {
          Alert.success(
            `Sending the waitlist SMS to ${data.queued} deal${data.queued === 1 ? "" : "s"} in the background — check Reporting for updates.`
          );
        }
        if (skipped.length > 0) {
          Alert.warning(
            `${skipped.length} deal${skipped.length === 1 ? " was" : "s were"} skipped: ${skipped
              .map(s => `#${s.deal_id || "-"} (${s.reason})`)
              .join(", ")}`
          );
        }
        if (data.queued === 0 && skipped.length === 0) {
          Alert.warning("Nothing was sent.");
        }
        setSending(false);
        onSent(data.deal_ids || []);
      })
      .catch(error => {
        const errorMsg = (error && error.data && error.data.error) || "Failed to send the waitlist SMS";
        Alert.error(errorMsg);
        setSending(false);
      });
  };

  const alreadySent = tasks.filter(
    t => t.waitlist_sms_days_ago !== null && t.waitlist_sms_days_ago !== undefined
  );

  return (
    <Modal show={show} onHide={onClose} dialogClassName="modal-lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Send Waitlist SMS to {tasks.length} Selected Task{tasks.length === 1 ? "" : "s"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-2">
          <strong className="mb-1">Notes:</strong>
          <div>- Messages are sent to all parent contacts associated with the deal.</div>
          <div>- Completed, Dead Deals & On Hold deals are skipped automatically.</div>
        </div>

        {alreadySent.length > 0 && (
          <BSAlert bsStyle="warning">
            {alreadySent.length} of the selected task{alreadySent.length === 1 ? " has" : "s have"} already
            received the waitlist SMS (deal{alreadySent.length === 1 ? "" : "s"}{" "}
            {alreadySent.map(t => `#${t.deal_id}`).join(", ")}).
          </BSAlert>
        )}

        {!loadingTemplate && !template && (
          <BSAlert bsStyle="danger">
            The waitlist SMS template could not be found in the messaging config.
          </BSAlert>
        )}

        <div style={{ marginBottom: 15 }}>
          <label className="d-block">Selected Deals:</label>
          <div id="bulk-sms-selected-deal-ids">
            {tasks.map(task => (
              <div
                key={task.id}
                className="bulk-sms-deal-id flex items-center border border-gray-300 text-sm px-2 py-1 rounded-full text-gray-700"
              >
                <span className="mr-2">Deal # {task.deal_id}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <label className="d-block strong">Message:</label>
          {loadingTemplate ? (
            <div className="text-muted">Loading...</div>
          ) : (
            template && (
              <div className="p-2" style={{ background: "#f5f5f5", border: "1px solid #ddd", borderRadius: 4 }}>
                <div style={{ whiteSpace: "pre-wrap" }}>{template.template_text}</div>
              </div>
            )
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} disabled={sending}>
          Whoops, cancel this
        </Button>
        <Button onClick={sendSms} disabled={!template || tasks.length < 1 || sending} bsStyle="success">
          {sending ? "Sending..." : "Send Waitlist SMS"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendTaskSmsModal;
